import React from "react";
// import { useState } from "react";
import snuffCup from "../images/collection/snuff-cup.png";
import headmask from "../images/collection/head-mask.png";
import headrest from "../images/collection/headrest.png";
import cowry from "../images/collection/cowry.png";
import sideDrum from "../images/collection/side-drum.png";
import legged from "../images/collection/legged.png";
import legged2 from "../images/collection/legged2.png";
import calabash from "../images/collection/calabash.png";
import calabash2 from "../images/collection/calabash2.png";
// import ArtifactModal from "./ArtifactModal";

const OurCollection = () => {
  // const [modalIsOpen, setModalIsOpen] = useState(false);
  // const [artId, setArtId] = useState(1);

  // const openModal = (e) => {
  //   setModalIsOpen(true);
  // };

  return (
    <div id="collection">
      {/* <ArtifactModal
        modalIsOpen={modalIsOpen}
        setModalIsOpen={setModalIsOpen}
        artId={artId}
      /> */}
      <div className="collection px-20 py-24 md:hidden">
        <h1 className="mb-12">OUR COLLECTION</h1>
        <div className="grid grid-cols-3 gap-10 items-end">
          <div
            className="group flex flex-col justify-end min-h-[500px]"
            // onClick={() => {
            //   openModal();
            //   setArtId(1);
            // }}
          >
            <div className="h-[200px] w-[210px] bg-apricot relative">
              <div className="absolute bottom-6 left-6 h-[370px] w-[280px]">
                <img
                  src={snuffCup}
                  alt=""
                  className="h-full group-hover:scale-110 transition-all delay-150"
                />
              </div>
            </div>
            <div className="p-6">
              <h1 className="text-lg">Suff Cup</h1>
            </div>
          </div>
          <div
            className="group self-start"
            // onClick={() => {
            //   openModal();
            //   setArtId(2);
            // }}
          >
            <div className="h-[124px] w-[274px] bg-transparent border-4 border-secondary  relative">
              <div className="absolute top-6 left-6 h-[252px] w-[363px]">
                <img
                  src={headmask}
                  alt=""
                  className="h-full group-hover:scale-110 transition-all delay-150"
                />
              </div>
            </div>
            <div className="p-6 mt-40">
              <h1 className="text-lg">Head Mask</h1>
            </div>
          </div>
          <div
            className="group flex flex-col justify-end items-end min-h-[500px]"
            // onClick={() => {
            //   openModal();
            //   setArtId(3);
            // }}
          >
            <div className="h-[200px] w-[210px] border-4 border-apricot relative">
              <div className="absolute bottom-6 right-6 h-[370px] w-[280px] flex justify-end">
                <img
                  src={headrest}
                  alt=""
                  className="h-full group-hover:scale-110 transition-all delay-150"
                />
              </div>
            </div>
            <div className="ml-14 p-6 self-start">
              <h1 className="text-lg">Headrest</h1>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-10 items-center justify-center -mt-20">
          <div
            className="group flex flex-col justify-center min-h-[500px]"
            // onClick={() => {
            //   openModal();
            //   setArtId(4);
            // }}
          >
            <div className="h-[252px] w-[363px]">
              <img
                src={cowry}
                alt=""
                className="h-full group-hover:scale-110 transition-all delay-150"
              />
            </div>
            <div className="p-6">
              <h1 className="text-lg">Cowry</h1>
            </div>
          </div>
          <div
            className="group flex flex-col justify-start items-end mr-8"
            // onClick={() => {
            //   openModal();
            //   setArtId(5);
            // }}
          >
            <div className="h-[200px] w-[210px] bg-apricot relative">
              <div className="absolute top-6 right-6 h-[428px] w-[306px]">
                <img
                  src={sideDrum}
                  alt=""
                  className="h-full group-hover:scale-110 transition-all delay-150"
                />
              </div>
            </div>
            <div className="mt-64 mr-40 p-6">
              <h1 className="text-lg">Double Side Drum</h1>
            </div>
          </div>
          <div
            className="group flex flex-col justify-center"
            // onClick={() => {
            //   openModal();
            //   setArtId(6);
            // }}
          >
            <div className="h-[252px] w-[363px]">
              <img
                src={legged}
                alt=""
                className="h-full group-hover:scale-110 transition-all delay-150"
              />
            </div>
            <div className="p-6">
              <h1 className="text-lg">Legged Masquerade</h1>
            </div>
          </div>
          <div className="empty"></div>
          <div
            className="group flex flex-col items-end"
            // onClick={() => {
            //   openModal();
            //   setArtId(7);
            // }}
          >
            <div className="h-[124px] w-[274px] bg-transparent border-4 border-secondary relative mt-10">
              <div className="absolute -top-1/2 right-6 h-[252px] w-[363px]">
                <img
                  src={calabash}
                  alt=""
                  className="h-full group-hover:scale-110 transition-all delay-150"
                />
              </div>
            </div>
            <div className="p-6 mt-20 self-start">
              <h1 className="text-lg">Calabash</h1>
            </div>
          </div>
        </div>
      </div>
      <div className="px-10 py-20 md-min:hidden">
        <h1 className="mb-12 text-2xl text-center">OUR COLLECTION</h1>
        <div className="flex flex-col">
          <div className="flex space-x-3">
            <div className="flex-1">
              <div className="flex flex-col space-y-3">
                <div>
                  <img src={cowry} alt="" className="w-full" />
                </div>
                <div>
                  <img src={headmask} alt="" className="w-full" />
                </div>
                <div>
                  <img src={calabash2} alt="" className="w-full" />
                </div>
                <div>
                  <img src={sideDrum} alt="" className="w-full" />
                </div>
              </div>
            </div>
            <div className="flex-1">
              <div className="flex flex-col space-y-3">
                <div>
                  <img src={snuffCup} alt="" className="w-full" />
                </div>
                <div>
                  <img src={headrest} alt="" className="w-full" />
                </div>
                <div>
                  <img src={legged2} alt="" className="w-full" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurCollection;
